import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../app/axiosInterceptor';
import {
  toRejectPayload,
  setHistoryError,
  clearHistoryError,
  clearAllHistoryErrors
} from './historyError';

//hanh trinh xe chay
export const reportSliceBGT = createAsyncThunk(
  'report/reportSliceBGT',
  ({ licensePlate = '', groupID = '', firstTime = '', lastTime = '', previousId = '', pageSize = 30, action = '', agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/route/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&previousId=${previousId}&pageSize=${pageSize}&action=${action}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//reportTocDocuaXe
export const reportTocDocuaXe = createAsyncThunk(
  'report/reportTocDocuaXe',
  ({ licensePlate = '', groupID = '', firstTime = '', lastTime = '', previousId = '', pageSize = 30, action = '', agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/speed/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&previousId=${previousId}&pageSize=${pageSize}&action=${action}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//quaTocDoGioiHan
export const quaTocDoGioiHan = createAsyncThunk(
  'report/quaTocDoGioiHan',
  ({ licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/overspeed/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//thoiGianLaiXeLientuc
export const thoiGianLaiXeLientuc = createAsyncThunk(
  'report/thoiGianLaiXeLientuc',
  ({ type = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/drivetime/data?type=${type}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);


//BaoCaoTongHopTheoXe
export const BaoCaoTongHopTheoXe = createAsyncThunk(
  'report/BaoCaoTongHopTheoXe',
  ({ licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/general/vehicle/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoTongHopTheoLaiXe
export const BaoCaoTongHopTheoLaiXe = createAsyncThunk(
  'report/BaoCaoTongHopTheoLaiXe',
  ({ license_number = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/general/driver/data?driverLicense=${license_number}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoDungDo
export const BaoCaoDungDo = createAsyncThunk(
  'report/BaoCaoDungDo',
  ({ licensePlate = '', groupID = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, agencyId }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/stop/data?licensePlate=${licensePlate}&groupID=${groupID}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
        // ,data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//BaoCaoHinhAnh
export const getBaoCaoHinhAnh = createAsyncThunk(
  'report/BaoCaoHinhAnh',
  ({ licensePlate = '', firstTime = '', lastTime = '', page = 1, pageSize = 30, camera = '', agencyId }, { rejectWithValue }) => {
    const action = camera === 'Tất cả camera' ? '' : camera;
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_REPORT_URL}/api/v1/report/agency/${agencyId}/image/data?licensePlate=${licensePlate}&firstTime=${firstTime}&lastTime=${lastTime}&page=${page}&pageSize=${pageSize}&camera=${action}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//license_plate
export const licensePlate = createAsyncThunk(
  'report/licensePlate',
  ({ rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/vehicles/tracking/agency/${localStorage.getItem('agency-id')}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);


//enduser for admin QC 31
export const getEndUserQc31 = createAsyncThunk(
  'report/getEndUserQc31',
  ({ id }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/users/get/all/enduser?device_type_id=1&device_type_id=2&device_type_id=7&device_type_id=8`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//driver for agency QC 31
export const getDriverQc31 = createAsyncThunk(
  'report/getDriverQc31',
  ({ id }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/drivers/agency/${id}?page_size=1000`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//driver for user QC 31
export const getDriverForUserQc31 = createAsyncThunk(
  'report/getDriverQc31',
  ({ id }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/drivers/end_user/${id}?page_size=1000`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);


// list license_plate
export const getLicensePlateQc31 = createAsyncThunk(
  'report/getLicensePlateQc31',
  ({ id, business_number }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/vehicles/license_plate/qc31/report/${id}?business=${business_number}&page_size=1000`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

//group_id 
export const groupID = createAsyncThunk(
  'report/groupID',
  ({ rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/group_device/?agency_id=${localStorage.getItem('agency-id')}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , Authorization: 'Bearer ' + localStorage.getItem('access-token')
        }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(rejectWithValue(toRejectPayload(err)));
        });
    });
  }
);

export const reportSlice = createSlice({
  name: 'report',
  initialState: {
    historyErrors: {},
    licensePlateQc: null,
    listDriverQc: null,
    dataLicensePlate: null,
    dataGroupID: null,
    listUserQC31: [],

    dataReportBGT: null,
    dataReportTocDocuaXe: null,
    dataQuaTocDoGioiHan: null,
    dataThoiGianLaiXeLientuc: null,
    dataBaoCaoTongHopTheoXe: null,
    dataBaoCaoTongHopTheoLaiXe: null,
    dataBaoCaoDungDo: null,
    dataBaoCaoHinhAnh: null,

    isLoading: false

  },
  reducers: {
    resetDataSceen: state => {
      clearAllHistoryErrors(state);
      state.dataReportBGT = null;
      state.dataReportTocDocuaXe = null;
      state.dataQuaTocDoGioiHan = null;
      state.dataThoiGianLaiXeLientuc = null;
      state.dataBaoCaoTongHopTheoXe = null;
      state.dataBaoCaoTongHopTheoLaiXe = null;
      state.dataBaoCaoDungDo = null;
      state.dataBaoCaoHinhAnh = null;
      state.listDriverQc = null;
      state.licensePlateQc = null;
    },

    resetListLicense: state => {
      state.licensePlateQc = null;
    }
  },
  extraReducers: {

    [reportSliceBGT.pending]: state => {
      clearHistoryError(state, 'reportSliceBGT');
      state.isLoading = true;
    },
    [reportSliceBGT.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportSliceBGT');
      state.dataReportBGT = action.payload;
      state.isLoading = false;
    },
    [reportSliceBGT.rejected]: (state, action) => {
      setHistoryError(state, 'reportSliceBGT', action);
      state.dataReportBGT = null;
      state.isLoading = false;
    },

    /////1 Hanh trinh chay xe


    [reportTocDocuaXe.pending]: state => {
      clearHistoryError(state, 'reportTocDocuaXe');
      state.isLoading = true;
    },
    [reportTocDocuaXe.fulfilled]: (state, action) => {
      clearHistoryError(state, 'reportTocDocuaXe');
      state.dataReportTocDocuaXe = action.payload;
      state.isLoading = false;
    },
    [reportTocDocuaXe.rejected]: (state, action) => {
      setHistoryError(state, 'reportTocDocuaXe', action);
      state.dataReportTocDocuaXe = null;
      state.isLoading = false;
    },
    /// 2 reportTocDocuaXe

    [quaTocDoGioiHan.pending]: state => {
      clearHistoryError(state, 'quaTocDoGioiHan');
      state.isLoading = true;
    },
    [quaTocDoGioiHan.fulfilled]: (state, action) => {
      clearHistoryError(state, 'quaTocDoGioiHan');
      state.dataQuaTocDoGioiHan = action.payload;
      state.isLoading = false;
    },
    [quaTocDoGioiHan.rejected]: (state, action) => {
      setHistoryError(state, 'quaTocDoGioiHan', action);
      state.dataQuaTocDoGioiHan = null;
      state.isLoading = false;
    },
    /// 3 quaTocDoGioiHan

    [thoiGianLaiXeLientuc.pending]: state => {
      clearHistoryError(state, 'thoiGianLaiXeLientuc');
      state.isLoading = true;
    },
    [thoiGianLaiXeLientuc.fulfilled]: (state, action) => {
      clearHistoryError(state, 'thoiGianLaiXeLientuc');
      state.dataThoiGianLaiXeLientuc = action.payload;
      state.isLoading = false;
    },
    [thoiGianLaiXeLientuc.rejected]: (state, action) => {
      setHistoryError(state, 'thoiGianLaiXeLientuc', action);
      state.dataThoiGianLaiXeLientuc = null;
      state.isLoading = false;
    },
    /// 4 thoiGianLaiXeLientuc

    [BaoCaoTongHopTheoXe.pending]: state => {
      clearHistoryError(state, 'BaoCaoTongHopTheoXe');
      state.isLoading = true;
    },
    [BaoCaoTongHopTheoXe.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTongHopTheoXe');
      state.dataBaoCaoTongHopTheoXe = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTongHopTheoXe.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTongHopTheoXe', action);
      state.dataBaoCaoTongHopTheoXe = null;
      state.isLoading = false;
    },
    /// 5 BaoCaoTongHopTheoXe

    [BaoCaoTongHopTheoLaiXe.pending]: state => {
      clearHistoryError(state, 'BaoCaoTongHopTheoLaiXe');
      state.isLoading = true;
    },
    [BaoCaoTongHopTheoLaiXe.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoTongHopTheoLaiXe');
      state.dataBaoCaoTongHopTheoLaiXe = action.payload;
      state.isLoading = false;
    },
    [BaoCaoTongHopTheoLaiXe.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoTongHopTheoLaiXe', action);
      state.dataBaoCaoTongHopTheoLaiXe = null;
      state.isLoading = false;
    },
    /// 6 BaoCaoTongHopTheoLaiXe

    [BaoCaoDungDo.pending]: state => {
      clearHistoryError(state, 'BaoCaoDungDo');
      state.isLoading = true;
    },
    [BaoCaoDungDo.fulfilled]: (state, action) => {
      clearHistoryError(state, 'BaoCaoDungDo');
      state.dataBaoCaoDungDo = action.payload;
      state.isLoading = false;
    },
    [BaoCaoDungDo.rejected]: (state, action) => {
      setHistoryError(state, 'BaoCaoDungDo', action);
      state.dataBaoCaoDungDo = null;
      state.isLoading = false;
    },
    ///  BaoCaoTongHinhAnh

    [getBaoCaoHinhAnh.pending]: state => {
      clearHistoryError(state, 'getBaoCaoHinhAnh');
      state.isLoading = true;
    },
    [getBaoCaoHinhAnh.fulfilled]: (state, action) => {
      clearHistoryError(state, 'getBaoCaoHinhAnh');
      state.dataBaoCaoHinhAnh = action.payload;
      state.isLoading = false;
    },
    [getBaoCaoHinhAnh.rejected]: (state, action) => {
      setHistoryError(state, 'getBaoCaoHinhAnh', action);
      state.dataBaoCaoHinhAnh = null;
      state.isLoading = false;
    },
    /// 7 BaoCaoDungDo

    /////licensePlate
    [licensePlate.pending]: state => {

    },

    [licensePlate.fulfilled]: (state, action) => {
      state.dataLicensePlate = action.payload.payload.latest_periodics;
    },

    [licensePlate.rejected]: (state, action) => {
      state.dataLicensePlate = null;

    },

    [getLicensePlateQc31.pending]: state => {

    },

    [getLicensePlateQc31.fulfilled]: (state, action) => {
      state.licensePlateQc = action.payload.payload.result.result;
    },

    [getLicensePlateQc31.rejected]: (state, action) => {
      state.dataLicensePlate = null;
      state.licensePlateQc = [];
    },

    [getDriverQc31.pending]: state => {

    },

    [getDriverQc31.fulfilled]: (state, action) => {
      state.listDriverQc = action.payload.payload.drivers;
    },

    [getDriverQc31.rejected]: (state, action) => {
      state.listDriverQc = null;
    },

    [getDriverForUserQc31.pending]: state => {

    },

    [getDriverForUserQc31.fulfilled]: (state, action) => {
      state.listDriverQc = action.payload.payload.drivers;
    },

    [getDriverForUserQc31.rejected]: (state, action) => {
      state.listDriverQc = null;
    },
    [getEndUserQc31.pending]: state => { },

    [getEndUserQc31.fulfilled]: (state, action) => {
      state.listUserQC31 = action.payload.payload;
    },

    [getEndUserQc31.rejected]: (state, action) => {
      state.listDriverQc = null;
    },

    /////group_device
    [groupID.pending]: state => {

    },

    [groupID.fulfilled]: (state, action) => {
      state.dataGroupID = action.payload.payload.groupDevices;
    },

    [groupID.rejected]: (state, action) => {
      state.dataGroupID = null;
    },


  }
});

export const {
  resetDataSceen,
  resetListLicense
} = reportSlice.actions;

export default reportSlice.reducer;
